/*
 * Rebuy price display — hide a "compare at" price that just repeats the price.
 *
 * Rebuy decides what to print as the struck-through price in
 * Widget.variantCompareAtPrice():
 *
 *   config.discount.type !== 'none'
 *     ? (config.discount.discounted_from === 'compare_at_price' && compare_at
 *         ? compare_at
 *         : price)
 *     : (compare_at > price ? compare_at : price)
 *
 * So any widget that has a discount configured — even a $0 one — stops reading
 * the variant's real compare-at price and prints the price itself instead. On
 * the PDP "Bundle & Save" widget (303855, discount: fixed $0, discounted from
 * original price) that renders the Sculpt & Soothe Set as "$99.00 $99.00", with
 * the second one struck through, instead of "$99.00 $124.00".
 *
 * The fix belongs in the Rebuy admin — set that widget's discount type to None,
 * and Rebuy falls back to the real compare-at. This is only the safety net: a
 * struck-through price identical to the price it sits next to is wrong in every
 * case, so hide it wherever it shows up. Once the widget is corrected the two
 * values differ and this leaves them alone.
 */
(function () {
  var SELECTOR = '.rebuy-product-price, .rebuy-bundle__actions';

  // Rebuy puts a screen-reader label ("Sale price" / "Original price") inside
  // each money element, so compare the visible text only.
  function visibleText(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.sr-only').forEach(function (n) {
      n.remove();
    });
    return clone.textContent.replace(/\s+/g, '');
  }

  function tidy(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (group) {
      var sale = group.querySelector('.rebuy-money.sale');
      var compare = group.querySelector('.rebuy-money.compare-at');
      if (!sale || !compare) return;

      var redundant = visibleText(sale) === visibleText(compare);
      compare.hidden = redundant;
      // Rebuy re-renders through Vue and can hand back an element we already
      // touched, so drive both directions rather than only hiding.
      compare.style.display = redundant ? 'none' : '';
    });
  }

  function start() {
    tidy(document);

    // Rebuy mounts and re-renders its widgets long after DOMContentLoaded, so
    // watch for them — coalesced to one pass per frame, because the observer
    // sees every node the widgets add while they build themselves.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        tidy(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
